import { useContext, useMemo } from 'react';
import { TagContext } from 'app/state/contexts/TagContext';
import { getTagHighlightColor, getTagIndicatorColor } from './colors';
import { TagBinding } from '../types/block';

export function useBlockTagColors(bindings: TagBinding[] | undefined): {
  highlight: string;
  indicator: string;
  isHidden: boolean;
} | null {
  const ctx = useContext(TagContext) as
    | {
        highlightedOption?: any;
        tagDataMap?: Record<string, any>;
        visibilityOption?: string[];
        extensionConceptIds?: Set<string>;
      }
    | undefined;

  return useMemo(() => {
    if (!bindings || bindings.length === 0) return null;
    const { highlightedOption, tagDataMap, visibilityOption, extensionConceptIds } = ctx ?? {};
    const firstId = bindings[0]?.tagId;
    if (!firstId) return null;
    const tagData = tagDataMap?.[firstId];

    const isExtension = !!(tagData?.conceptId && extensionConceptIds?.has(tagData.conceptId));
    const visibilityKey = isExtension ? 'extension' : 'core';
    const isHidden = Array.isArray(visibilityOption) && !visibilityOption.includes(visibilityKey);

    if (isHidden) {
      return { highlight: 'transparent', indicator: 'transparent', isHidden: true };
    }
    if (isExtension) {
      return { highlight: '#ffd8f5', indicator: '#ff9de7', isHidden: false };
    }
    return {
      highlight: getTagHighlightColor(highlightedOption, tagData),
      indicator: getTagIndicatorColor(highlightedOption, tagData),
      isHidden: false,
    };
  }, [bindings, ctx]);
}

export function blockTagHighlightStyle(colors: { highlight: string; indicator: string }) {
  return {
    backgroundColor: colors.highlight,
    borderLeft: `4px solid ${colors.indicator}`,
    borderRight: `4px solid ${colors.indicator}`,
    borderRadius: '13px',
  };
}

export function textBlockTagRegionStyle(colors: { highlight: string }) {
  return {
    backgroundColor: colors.highlight,
  };
}
